<!-- eslint-disable @angular-eslint/template/no-call-expression -->

@if (piece && shouldDisplayComponent()) {
  <idt-common-styles-render [styles]="piece.settings?.styles">
    <div class="concluded-events__media">
      @let orientation = orientation$ | async;
      @if (orientation === 'landscape') {
        @let lazySrc = getLandscapeImageSrc();
        <img
          class="concluded-events__image"
          [lazySrc]="lazySrc"
          [preRender]="!!settings.general?.preloadImage"
          alt="{{ (lazySrc.src! | getAltText | async) || '' }}">
      } @else {
        @let lazySrc = getPortraitImageSrc();
        <img
          class="concluded-events__image"
          [lazySrc]="lazySrc"
          [preRender]="!!settings.general?.preloadImage"
          alt="{{ (lazySrc.src! | getAltText | async) || '' }}">
      }
    </div>
    <div class="concluded-events__content">
      @if ( settings.general?.title) {
        <div class="concluded-events__title">
          {{ settings.general?.title }}
        </div>
      }
      <div class="concluded-events__info">
        @if ( settings.general?.location) {
          <div class="concluded-events__location">
            {{ settings.general?.location }}
          </div>
        }
        @if ( settings.general?.date) {
          <div class="concluded-events__date">
            <div>{{ settings.general?.date | safeDate:'EEEE, d MMMM':undefined:languageTag | titlecase }}</div>
            <div>{{ settings.general?.date | safeDate:'HH:mm':undefined:languageTag }}</div>
          </div>
        }
      </div>
      @if (settings.general?.description) {
        <div
          class="wysiwyg concluded-events__description"
          role="region"
          aria-label="Event Description">
          <render-wysiwyg
            [html]="settings.general?.description"
            [country]="country"
            [lang]="lang"
            [piece]="piece">
          </render-wysiwyg>
        </div>
      }
      @if (settings.general?.galleryCtaText && settings.general?.galleryLink) {
        <div class="concluded-events__actions">
          <a
            class="concluded-events__cta"
            [href]="settings.general?.galleryLink"
            [attr.data-gallery-id]="settings.general?.galleryId"
            target="_blank"
            rel="noopener noreferrer"
            (click)="onGalleryClick($event)">
            {{ settings.general?.galleryCtaText }}
          </a>
        </div>
      }
    </div>
  </idt-common-styles-render>
}
